import { getAsJson, validateParams } from './AbstractService';

import { ConstantesApi } from '@common/utils';


export const fetchProductHistory = (params, endpoint = ConstantesApi.API_PRODUCT_HISTORY) => {
    validateParams(params);
    return getAsJson({ api: endpoint, ...params });
}; 